import React, { useMemo, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import ForceGraph2D from "react-force-graph-2d";
import classes from "./Waitlist.module.css";

const funnyTopics = [
  "Pigeon WiFi",
  "AI Overlords",
  "Banana Economics",
  "Quantum Tacos",
  "Flat Mars Society",
  "Cat Lawyers",
  "Unicorn Startups",
  "Infinite Pizza",
  "Dogecoin Philosophy",
  "Time Travel Etiquette",
  "Cloud Surfing",
  "Coffee-Powered AI",
  "Banana Phones",
  "Cosmic Burritos",
  "Penguin Politics",
  "AI Poetry Slams",
  "Solar-Powered Pigeons",
  "Virtual Reality Pizza",
  "Space Karaoke",
  "Octopus Economists",
  "Teleporting Sandwiches",
  "Blockchain Bananas",
  "Quantum Karaoke",
  "AI Dungeon Masters",
  "Punk Rock Unicorns",
  "Moonlight Coding",
  "Multiverse Donuts",
  "Meme Stock Philosophy",
  "Cheese-Based Currencies",
  "Holographic Cats",
];

const WaitlistPage = () => {
  const fgRef = useRef();

  // Generate denser graph
  const graphData = useMemo(() => {
    const nodes = funnyTopics.map((t, i) => ({ id: i, name: t }));
    const links = [];

    // Each node connects to 2–4 others
    nodes.forEach((node) => {
      const numLinks = 2 + Math.floor(Math.random() * 3); // 2-4 links
      for (let j = 0; j < numLinks; j++) {
        const target = Math.floor(Math.random() * nodes.length);
        if (target !== node.id) {
          links.push({ source: node.id, target });
        }
      }
    });

    return { nodes, links };
  }, []);

  useEffect(() => {
    if (fgRef.current) {
      // Auto-zoom to fit graph once rendered
      setTimeout(() => {
        fgRef.current.zoomToFit(400, 50); // 400ms animation, 50px padding
      }, 500);
    }
  }, [graphData]);

  return (
    <div className={classes.container}>
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Hold tight. I'll let you in soon. 🚪
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className={classes.desc}
      >
        We’re curating your spot in the flow.
      </motion.p>

      <div className={classes.graphWrapper}>
        <ForceGraph2D
          ref={fgRef}
          graphData={graphData}
          nodeCanvasObject={(node, ctx, globalScale) => {
            const label = node.name;
            const fontSize = 14 / globalScale;
            ctx.font = `${fontSize}px Sans-Serif`;
            ctx.fillStyle = "#222";
            ctx.textAlign = "center";
            ctx.fillText(label, node.x, node.y + 8);
          }}
          nodeRelSize={6}
          linkColor={() => "#aaa"}
          linkWidth={1}
          backgroundColor="#fafafa"
        />
      </div>
    </div>
  );
};

export default WaitlistPage;
